var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "#C2DFE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User Info - tasks",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-324 -688)",
    fill: "#F2F8FD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 99"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -219,
    y: -229,
    width: 1305,
    height: 846,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -219.5,
    y: -229.5,
    width: 1306,
    height: 847,
    rx: 10.5,
    stroke: "black",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 301",
    x: -219,
    y: -229,
    width: 1308,
    height: 857,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Total Sales & Cost"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1308,
    height: 834,
    transform: "translate(-219 -89)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: -219,
    y: -89,
    width: 1308,
    height: 834,
    rx: 18.383,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table Row"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077 43.1276H-219V45.4254H1077V43.1276Z",
    fill: "#E9E7FD",
    mask: "url(#path-5-inside-1_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Table Row_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M9 0L17.6603 15H0.339746L9 0Z",
    fill: "#E84C3B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1077 314.787H-219V317.085H1077V314.787Z",
    fill: "#E9E7FD",
    mask: "url(#path-7-inside-2_0_1)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-324 -688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriority);
export default __webpack_public_path__ + "static/media/highPriority.7ef546cf08f56bc0a23ded4ffef4f699.svg";
export { ForwardRef as ReactComponent };